import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import type { Moment } from 'moment';
import { ChartRangeOptions } from '@core/models';
import { TelemetryPeriod } from '@core/constants/telemetry-route.constant';
import { PeriodSelectorComponent } from '../period-selector/period-selector.component';
import { TimeSelectorComponent } from '../time-selector/time-selector.component';

@Component({
  selector: 'xemex-time-controls',
  standalone: true,
  imports: [PeriodSelectorComponent, TimeSelectorComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './time-controls.component.html',
})
export class TimeControlsComponent {
  options = input<ChartRangeOptions[]>([]);
  selected = input<ChartRangeOptions>(ChartRangeOptions.Day);
  isTopological = input<boolean>(false);
  initialDate = input<Moment | null>(null);
  /** Draws the period and date controls as white bordered boxes, like cards. */
  framed = input<boolean>(false);

  selectedChange = output<ChartRangeOptions>();
  change = output<string>();
  periodChange = output<TelemetryPeriod>();
  selectedDate = output<Moment | null>();

  readonly ChartRangeOptions = ChartRangeOptions;
}
